import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { filter, includes } from 'lodash-es';

class Accordion extends Component {
  static defaultProps = {
    maxHeight: 999,
    open: false,
    availableItems: [],
    hasBottomLine: false,
  }
  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
    maxHeight: PropTypes.number,
    open: PropTypes.bool,
    active: PropTypes.bool,
    hasBottomLine: PropTypes.bool,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    boxClassName: PropTypes.string,
    anchor: PropTypes.string,
    availableItems: PropTypes.array,
    onOpen: PropTypes.func.isRequired,
  };
  componentDidMount() {
    this.accordionContent.addEventListener('transitionend', this.showHideAccordionContent, false);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.accordionContent.style.overflow = this.props.open ? 'visible' : 'hidden';
    }
  }
  showHideAccordionContent = (e) => {
    if (this.props.open) { e.target.style.overflow = 'visible'; }
  }
  handleHeaderClick = () => {
    this.accordionContent.style.overflow = 'hidden';
    this.props.onOpen(!this.props.open);
  };
  renderChildren = () => {
    const { children, availableItems } = this.props;
    if (availableItems.length === 0) { return children; }
    return filter(React.Children.toArray(children), c => includes(availableItems, c.props.itemId) || c.type === 'p');
  }
  render() {
    const {
      title, subtitle, maxHeight, className, anchor, open, active, hasBottomLine, buttonClassName, boxClassName,
    } = this.props;
    const children = this.renderChildren();
    if (children.length === 0) { return null; }
    return (
      <div
        id={anchor}
        className={cx('accordion', className)}
      >
        <button
          type="button"
          className={cx('btn btn-outline btn-block d-flex align-items-center text-left px-md pt-md pb-sm accordion-btn',
            buttonClassName, {
            active,
            'b-rds-0': !hasBottomLine && open,
            'b-rds-bottom': hasBottomLine && !open,
          })}
          onClick={this.handleHeaderClick}
        >
          <div
            className="flex-no-shrink img-circle pos-rel transitionable"
            style={{ width: 24, height: 24, backgroundColor: '#fff' }}
          >
            <div
              className="horizontal-line center-x-y"
              style={{
                width: 11,
                height: 2,
                borderRadius: 1,
              }}
            />
            <div
              className="vertical-line center-x-y transitionable"
              style={{
                width: 2,
                height: open ? 0 : 11,
                borderRadius: 1,
                opacity: open ? 0 : 1,
              }}
            />
          </div>
          <div className="flex-grow">
            <p className="text-sm text-white" style={{ whiteSpace: 'initial' }}>{title}</p>
            {subtitle && (
              <p
                className="accordion-subtitle text-xs text-light mt-xxxs"
                style={{ whiteSpace: 'normal', color: '#f8f8f8' }}
              >{subtitle}
              </p>
            )}
          </div>
        </button>
        <div
          className={cx('px-md transitionable', boxClassName, {
            'accordion-footer b-rds-bottom': hasBottomLine && open,
          })}
          style={{
            overflow: 'hidden',
            maxHeight: open ? maxHeight : 0,
            paddingTop: open ? 20 : 0,
            paddingBottom: open ? 20 : 0,
          }}
          ref={(ref) => { this.accordionContent = ref; }}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default Accordion;
